import { Button, classNames } from '@cma/common'

interface UseDifferentEmailButtonProps {
  onClick(): void
  className?: string
}

export function UseDifferentEmailButton({
  onClick,
  className
}: UseDifferentEmailButtonProps) {
  return (
    <div className={classNames('flex justify-center', className || '')}>
      <Button
        type="button"
        variant="ghost-secondary"
        size="sm"
        onClick={onClick}>
        Use a different email
      </Button>
    </div>
  )
}
